// extracted by mini-css-extract-plugin
module.exports = {"popup__head":"Header_popup__head__2Eo7H","popup__title":"Header_popup__title__1bfnJ","popup__close":"Header_popup__close__1JWVs","popup__descr":"Header_popup__descr__3ZxhQ"};